import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import "../index.css";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng); // Save selected language to localStorage
  };

  const options = [
    {
      value: "en",
      label: (
        <>
          <ReactCountryFlag countryCode="GB" svg /> English
        </>
      ),
    },
    {
      value: "la",
      label: (
        <>
          <ReactCountryFlag countryCode="LA" svg /> ລາວ
        </>
      ),
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      width: "105px",
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "40px",
      padding: "0 8px",
      backgroundColor: "transparent",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
      pointerEvents: "none",
      backgroundColor: "transparent",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
      backgroundColor: "transparent",
    }),
    singleValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      color: "var(--text-color)",
      height: "40px",
      backgroundColor: "transparent",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px",
      color: "green",
      backgroundColor: "transparent",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "green"
        : state.isFocused
        ? "#e0e0e0"
        : "transparent",
      color: state.isSelected ? "#fff" : "#000",
    }),
  };

  return (
    <div className="lang-bt">
      <Select
        options={options}
        defaultValue={options.find(
          (option) =>
            option.value === (localStorage.getItem("language") || i18n.language)
        )}
        onChange={(option) => changeLanguage(option.value)}
        styles={customStyles}
        isSearchable={false}
      />
    </div>
  );
};

export default LanguageSelector;
